module.exports = __webpack_public_path__ + "static/template-team-member-3-a7512e9ed1d63676849123cd4886d7b5.jpg";